<template>
  <Timeline :style="{backgroundColor: '#fff'}">
    <TimelineItem :style="{padding: '15px'}" :color="item.color" v-for="item in logs_own" :key="item.id">
      <p class="time log-content">{{ item.datetime_format }}</p>
      <p class="log-content"><b>操作人：</b>{{ item.user_full_name }}</p>
      <p class="log-content"><b>操作结果：</b>{{ item.result }}</p>
      <b class="log-content">操作内容：</b>
      <json-viewer
        :value="getJson(item.content_json)"
        :expand-depth="3"></json-viewer>
    </TimelineItem>
  </Timeline>
</template>
<script>
import { getJsonFun } from '../../../src/libs/tools'
export default {
  name: 'cron-operation-logs',
  props: ['logs'],
  data () {
    return {
      logs_own: this.logs
    }
  },
  watch: {
    logs () {
      let logsTmp = []
      this.logs.map((item, index) => {
        if (item.type === 'error') {
          item['color'] = 'red'
        } else {
          item['color'] = 'green'
        }
        logsTmp.push(item)
      })
      this.logs_own = logsTmp
    }
  },
  methods: {
    getJson (data) {
      return getJsonFun(data)
    }
  },
  mounted: function () {
  }
}
</script>
<style>
  .time{
    font-weight: bold;
  }
  .log-content {
    font-size: 14px;
  }
  pre {
    white-space: pre-wrap;
    word-wrap: break-word;
  }
  .code-con{
    background: #F9F9F9;
  }
</style>
